import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';

// Interfaces
import { Subject } from 'rxjs';

import { EPicklistOderStatus } from '../../../picklist/interfaces/picklist.interface';
import { trackByValue } from '../../../shared/util/track-by.util';
import { ISalesOrderStatus } from '../../interfaces';

@Component({
  selector: 'lum-sales-order-status-tab',
  templateUrl: './sales-order-status-tab.component.html',
  styleUrls: ['./sales-order-status-tab.component.scss'],
})
export class SalesOrderStatusTabComponent implements OnDestroy {
  @Input()
  data :ISalesOrderStatus[];

  @Input()
  loading :boolean = false;

  @Input()
  activeFilter :string | null = null;

  @Output()
  setStatusEvent = new EventEmitter<string | null>();

  skeletonItems = Array(4).fill(null);

  trackByValue = trackByValue;
  private onDestroy$ = new Subject();

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSetStatus(status :EPicklistOderStatus) :void {
    this.activeFilter = status;
    this.setStatusEvent.emit(status);
  }

  onResetStatus() :void {
    this.setStatusEvent.emit(null);
    this.activeFilter = EPicklistOderStatus.PENDING;
  }
}
